<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="wallet" class="margin-right-small" />
        Cash On Hand/Bank List
      </span>
    </div>
    <div class="wrapper-body">
      <a-tabs
        class="custom-tabs"
      >
        <a-tab-pane key="onbanktab" >
          <template slot="tab">
              <span>On Bank</span>&nbsp;
          </template>
          <div class="m-display-flex flex-row space-between margin-small" style="flex-wrap: initial;">
            <a-select 
              showSearch
              allowClear 
              placeholder="Search by Bank Account"
              v-model="search" class="width-full"
              optionFilterProp="children"
              :filterOption="filterOption"
              >
              <a-select-option v-for="item in accountBank" :key="item.value">{{item.text}}</a-select-option>
            </a-select>
            <a-button icon="plus" type="primary" @click="handleCreate" style="margin-left:5px">
              <span>Create</span>
            </a-button>
          </div>
          <a-table
              :rowKey="(record, index) => {return index;}"
              size="small"
              class="margin-small"
              bordered
              :scroll="{ x: 1300 }"
              :columns="columns.onbank"
              :dataSource="onbanklist"
              :loading="loading"
            >
            <a
              slot="transaction"
              slot-scope="item"
              @click="handleLinkTransaction(item.jenis_transaksi, item.id)"
              >{{ item.no_transaction }}</a
            >
            <template slot="bankcount" slot-scope="text, data, index">
              <div class="m-display-flex nowrap space-between" style="justify-content: left;align-items: center;">
                <img :src="urllogo+'assets/bank/'+data.logo_bank" class="image_logo"
                v-bind:onerror="'this.src='+urllogonotfound"
                >
                  <!-- <a-avatar size="large" shape="square"
                  :src="urllogo+'assets/bank/'+data.logo_bank"
                  >
                    <template #icon><UserOutlined /></template>
                  </a-avatar> -->
                  <span>{{ data.nama_bank }} ({{data.kode_bank}})</span>
              </div>
            </template>
            <template slot="pemilik" slot-scope="data">
              {{data.pemilik ? data.pemilik : '-'}} ({{data.kode_rekening}})
            </template>
            <template slot="balance" slot-scope="text, data, index">
              <CurrencyJustified
                :currencyValue="data.currency"
                :valueNumber="(data.saldo?data.saldo:0)"
              />
            </template>
            <template slot="ebalance" slot-scope="text, data, index">
              <CurrencyJustified
                :currencyValue="data.currency"
                :valueNumber="(data.saldo_efektif?data.saldo_efektif:0)"
              />
            </template>
            <template slot="fundblok" slot-scope="text, data, index">
              <CurrencyJustified
                :currencyValue="data.currency"
                :valueNumber="(data.dana_blokir?data.dana_blokir:0)"
              />
            </template>
            <template slot="act" slot-scope="text, data">
                <a-button-group>
                  <a-button
                    type="primary"
                    @click="handleViewDtl(data)"
                  >View Detil</a-button>
                </a-button-group>
              </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="onhandtab">
          <template slot="tab">
              <span>On Hand</span>&nbsp;
          </template>
          <div class="m-display-flex flex-row space-between margin-small" style="flex-wrap: initial;">
            <a-select 
              showSearch
              allowClear 
              placeholder="Search by Petty Cash PIC"
              v-model="searchPic" class="width-full"
              optionFilterProp="children"
              :filterOption="filterOption"
              >
              <a-select-option v-for="item in onhandlist" :key="item.tlc">
                {{item.pic_kas_kecil}} ( {{item.tlc}} )
              </a-select-option>
            </a-select>
          </div>
          <a-table
              :rowKey="(record, index) => {return index;}"
              size="small"
              class="margin-small"
              bordered
              :scroll="{ x: 1300 }"
              :columns="columns.onhand"
              :dataSource="onhandlist"
              :loading="loading"
            >
            <template slot="pcpic" slot-scope="text, data, index">
              <div class="m-display-flex nowrap space-between" style="justify-content: left;align-items: center;">
                <div class="photos-wrapper">
                <img :src="data.foto_karyawan"
                v-bind:onerror="'this.src='+urllogonotfound"
                >
                  <!-- <a-avatar size="large" shape="square"
                  :src="urllogo+'assets/bank/'+data.logo_bank"
                  >
                    <template #icon><UserOutlined /></template>
                  </a-avatar> -->
                </div>
                <div>
                  <span>{{ data.pic_kas_kecil }}</span>
                </div>
              </div>
            </template>
            <template slot="quota" slot-scope="text, data, index">
              <CurrencyJustified
                :currencyValue="data.currency"
                :valueNumber="(data.quota?data.quota:0)"
              />
            </template>
            <template slot="usage" slot-scope="text, data, index">
              <CurrencyJustified
                :currencyValue="data.currency"
                :valueNumber="(data.pemakaian?data.pemakaian:0)"
              />
            </template>
            <template slot="balance" slot-scope="text, data, index">
              <CurrencyJustified
                :currencyValue="data.currency"
                :valueNumber="(data.saldo?data.saldo:0)"
              />
            </template>
            <template slot="act" slot-scope="text, data">
                <a-button-group>
                  <a-button
                    type="primary"
                    @click="handleViewDtlonHand(data)"
                  >View Detil</a-button>
                </a-button-group>
              </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>

    <a-modal
      v-if="modalCreate"
      v-model="modalCreate"
      :maskClosable="false"
      :closable="false"
      @ok="saveCreate()"
      ok-text="Save"
      cancel-text="Cancel"
      width="50%"
      @cancel="cancelCreate()"
      style="top: 20px!important"
    >
      <template slot="footer">
      <a-button key="back" :disabled="modal_loading" @click="cancelCreate">Cancel</a-button>
      <a-button key="submit" type="primary" :loading="modal_loading" @click="saveCreate">Save</a-button>
      </template>
      <template slot="title" class="title">
        <div class="ant-card-head-title" style="padding:0px;">
          <span><a-tag color="green">Create</a-tag>Bank Account</span>
        </div>
      </template>
        <a-form :form="form" autocomplete="off" class="margin-remove">
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <a-form-item label="Date">
                <a-date-picker
                  :disabled="true"
                  placeholder="Select Date"
                  :format="getDefaultDateFormat"
                  v-decorator="[
                    'date',
                    {
                      rules: [{ required: true, message: 'Date is required' }],
                      initialValue: moment(
                        new Date(),
                        getDefaultDateFormat
                      ),
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Bank Account Name">
                <!-- <a-auto-complete
                  v-decorator="['bankname',
                  {rules: [{ required: true, message: 'Bank Account Name is required' }],initialValue: null}]"
                  :data-source="listbank"
                  :filter-option="filterOption"
                /> -->
                <a-select
                  placeholder="Select Bank Account Name"
                  v-decorator="['bankname', 
                    { rules: [{ required: true, message: 'Bank Account Name is required' }] }]"
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                >
                  <a-select-option
                    v-for="item in listbank"
                    :key="item.value"
                    >{{ item.text }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Bank Account Code">
                <a-input v-decorator="['bankcode',
                  {rules: [{ required: true, message: 'Bank Account Code is required' }],initialValue: null}]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <a-form-item label="Owner">
                <a-input v-decorator="['owner',
                  {rules: [{ required: true, message: 'Owner is required' }],initialValue: null}]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Currency">
                <a-select
                  placeholder="Select Currency"
                  v-decorator="['currency', 
                    { rules: [{ required: true, message: 'Currency is required' }] }]"
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                >
                  <a-select-option
                    v-for="item in listcurrency"
                    :key="item.value"
                    >{{ item.text }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Bank account number">
                <a-input v-decorator="['accountnumber',
                  {rules: [{ required: true, message: 'Bank account number is required' }],initialValue: null}]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <a-form-item label="Swift Code">
                <a-input v-decorator="['swiftcode',
                  {rules: [{ required: true, message: 'Swift Code is required' }],initialValue: null}]"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Start Balance">
                <a-input v-decorator="['startbalance',
                  {rules: [{ required: true, message: 'Start Balance is required' }],initialValue: null}]"
                  @keydown="onlyNumber"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Address">
                <a-textarea
                class="m-width-full"
                v-decorator="[
                  'address',
                  {
                    rules: [{ required: true, message: 'Address is required'}],
                  },
                ]"
              ></a-textarea>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "cashOnHand-index",
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  data() {
    const columns = {
      onbank: [
        {
          title: "Bank",
          key: "bankcount",
          scopedSlots: { customRender: "bankcount" },
          width: 250,
        },
        {
          title: "Account",
          key: "pemilik",
          width: 200,
          scopedSlots: { customRender: "pemilik" },
        },
        {
          title: "Created By",
          key: "createby",
          width: 90,
          align:"center",
          dataIndex: "tlc_create",
        },
        {
          title: "Balance",
          key: "balance",
          width: 150,
          align:"right",
          scopedSlots: { customRender: "balance" },
        },
        {
          title: "Efective Balance",
          key: "ebalance",
          scopedSlots: { customRender: "ebalance" },
          width: 150,
          align:"right",
        },
        {
          title: "Blocked Fund",
          key: "fundblok",
          scopedSlots: { customRender: "fundblok" },
          width: 150,
          align:"right",
        },
        {
          title: "Action",
          key: "act",
          dataIndex: "act",
          width: 100,
          scopedSlots: { customRender: "act" },
          align: "center",
        },
      ],
      onhand: [
        {
          title: "TLC",
          key: "tlc",
          dataIndex: "tlc",
          width: 50,
          align:"center"
        },
        {
          title: "Petty Cash PIC",
          key: "pcpic",
          scopedSlots: { customRender: "pcpic" },
          width: 250,
        },
        {
          title: "Quota",
          key: "quota",
          width: 200,
          scopedSlots: { customRender: "quota" },
        },
        {
          title: "Usage",
          key: "usage",
          width: 150,
          scopedSlots: { customRender: "usage" },
        },
        {
          title: "Balance",
          key: "balance",
          scopedSlots: { customRender: "balance" },
          width: 150,
        },
        {
          title: "Action",
          key: "act",
          dataIndex: "act",
          width: 100,
          scopedSlots: { customRender: "act" },
          align: "center",
        },
      ],
    };
    return {
      columns,
      loading: false,
      search: undefined,
      searchPic: undefined,
      onbanklist:[],
      onbanklist_origin:[],
      onhandlist:[],
      onhandlist_origin:[],
      urllogo: this.$serviceUrl,
      urllogonotfound: '"'+this.$serviceUrl+'assets/bank/not-found.png"',
      accountBank: {},
      modalCreate: false,
      modal_loading: false,
      listcurrency: [],

    };
  },
  mounted() {
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
  },
  watch: {
    search()
      {
      if(this.search){
        this.onbanklist = _.filter(
          this.onbanklist_origin,
          (obj) => obj.kode_bank && obj.kode_bank.toLowerCase().indexOf(this.search.toLowerCase()) >= 0);
      }else{
        this.onbanklist = this.onbanklist_origin;
      }
    },
    searchPic()
      {
      if(this.searchPic){
        this.onhandlist = _.filter(
          this.onhandlist_origin,
          (obj) => obj.tlc && obj.tlc.toLowerCase().indexOf(this.searchPic.toLowerCase()) >= 0 ||
                   obj.pic_kas_kecil && obj.pic_kas_kecil.toLowerCase().indexOf(this.searchPic.toLowerCase()) >= 0);
      }else{
        this.onhandlist = this.onhandlist_origin;
      }
    },
  },
  beforeCreate(){
    this.form = this.$form.createForm(this);
  },
  created() {
    this.reload();
  },
  methods: {
    moment,
    reload(){
      this.loading=true;
      this.$store.dispatch("FetchDataInput", { auth: this.getAuth }).then((res) => {
        this.listcurrency = res.currency;
        this.listbank = res.bank_account;
      });
      this.$store.dispatch("getcashonbanklist", { auth: this.getAuth }).then((res) => {
        this.accountBank = res.data.bank_account;
      });
      this.$store.dispatch("getcashonbankdata", { auth: this.getAuth }).then((res) => {
          this.onbanklist = res.data.bank;
          this.onbanklist_origin = res.data.bank;

          this.onhandlist = res.data.hand;
          this.onhandlist_origin = res.data.hand;
          this.loading=false;
      });
    },
    handleCreate(){
      this.modalCreate = true;
    },
    saveCreate(){
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let postData = new FormData();
        postData.append("tlc", this.getAuth.username);
        postData.append("date", moment(values.date).format("YYYY-MM-DD"));
        postData.append("bank_account_name", values.bankname);
        postData.append("bank_code", values.bankcode);
        postData.append("owner", values.owner);
        postData.append("currency", values.currency);
        postData.append("rekening_no", values.accountnumber);
        postData.append("address", values.address);
        postData.append("swift_code", values.swiftcode);
        postData.append("balance", values.startbalance);

        this.modal_loading = true;
        this.$store.dispatch("savebankAccount", { auth: this.getAuth, params: postData })
        .then((res) => {
          this.modal_loading = false;
          this.modalCreate = false;
          this.search = null;
          this.reload();
          this.displayMessageValue("success-other", res.data.message);
        })
        .catch((error) => {
          this.modal_loading = false;
          let responses = Object.assign({}, error);
          if (responses.response.data) {
            this.displayMessageValue(
              "error-other",
              responses.response.data.message
            );
          } else {
            this.displayMessageValue("error-other", responses.response);
          }
        });
      });
    },
    cancelCreate(){
      this.modalCreate = false;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleViewDtl(val){
      let name = "cashonhand-manifest-keu";
      this.getAuth.divisi.forEach((element) => {
        if (element == "Akuntansi") {
          name = "cashonhand-manifest-acc";
        }
      });
      this.$router.push({
          name: name,
          params: { id: val.kode_bank, pages: "cashOnBank"},
        });
    },
    handleViewDtlonHand(val){
      let name = "cashonhand-manifest-keu";
      this.getAuth.divisi.forEach((element) => {
        if (element == "Akuntansi") {
          name = "cashonhand-manifest-acc";
        }
      });
      this.$router.push({
          name: name,
          params: { id: val.tlc, pages: "cashOnHand" },
        });
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }
    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead > tr > th {
  text-align: center;
}

.image_logo {
  max-width: 30%;
  max-height: 100%;
  margin-right: 10px;
  object-fit: scale-down;
}

.photos {
  &-wrapper {
    width: 64px;
    height: 86px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid white;
    // border-radius: 12px;
    margin-bottom: 3px;
    margin-right: 10px;

    -webkit-box-shadow: 0 3px 4px 0px #777;
	  -moz-box-shadow: 0 3px 4px 06px #777;
	  box-shadow: 0 3px 4px 0px #777;
    img {
      width: 100%;
      align-self: flex-start;
    }
  }
}
</style>
